import React from 'react';
import { useAgencies } from 'hooks/useAgencies';
import GroupPopup from './GroupPopup';
import './agencies-filters.scss';
import CarrierLogo from 'components/CarrierLogo/CarrierLogo';
import { Button, Label } from 'semantic-ui-react';

export default function AgenciesFilters({
  filterByOrigin = false,
  activeAgencies = [],
  onToggleAgency = () => {},
}) {
  const { agencies } = useAgencies(filterByOrigin);
  const groups = [...new Set(agencies.map((agency) => agency.group))];
  return (
    <div className="agencies-filters">
      {groups.length === 1 ? (
        <>
          <Label small className="agencies-filters__label">
            Agencia
          </Label>
          <div className="agencies-filters__buttons" role="listbox">
            {agencies.map((agency) => (
              <Button
                className="agencies-filters__filter"
                key={agency.id}
                toggle
                circular
                active={activeAgencies?.includes(agency.id)}
                size="mini"
                onClick={(event, data) => {
                  onToggleAgency(agency.id);
                }}
              >
                <CarrierLogo code={agency.agency_code} />
              </Button>
            ))}
          </div>
        </>
      ) : (
        <div className="agencies-filters__groups">
          {groups.map((group) => (
            <GroupPopup
              key={group}
              group={group}
              agencies={agencies}
              activeAgencies={activeAgencies}
              onToggleAgency={onToggleAgency}
            />
          ))}
        </div>
      )}
    </div>
  );
}
